import { render } from "./WorkName.vue?vue&type=template&id=11ea2cfa&scoped=true"
import script from "./WorkName.vue?vue&type=script&lang=js"
export * from "./WorkName.vue?vue&type=script&lang=js"

import "./WorkName.vue?vue&type=style&index=0&id=11ea2cfa&lang=scss&scoped=true"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ea2cfa"]])

export default __exports__